import { AxiosPromise } from "axios";
import { request } from "utils/request";

interface ConversationListParam {
  projectId: number;
  page?: number;
  limit?: number;
}

interface CreateConversationParam {
  projectId: number;
  name?: string;
}

interface MessageListParam {
  page?: number;
  limit?: number;
}

interface UpdateConversationParam {
  conversation: {
    name: string;
  };
}

export const conversationApi = {
  getList: (params: ConversationListParam): AxiosPromise<any> =>
    request({
      url: "/v1/admin/conversations",
      method: "get",
      params,
    }),

  create: (data: CreateConversationParam): AxiosPromise<any> =>
    request({
      url: "/v1/admin/conversations",
      method: "post",
      data,
    }),

  getMessages: (conversationId: number, params?: MessageListParam): AxiosPromise<any> =>
    request({
      url: `/v1/admin/conversations/${conversationId}/messages`,
      method: "get",
      params,
    }),

  update: (conversationId: number, data: UpdateConversationParam): AxiosPromise<any> =>
    request({
      url: `/v1/admin/conversations/${conversationId}`,
      method: "patch",
      data,
    }),

  remove: (conversationId: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/conversations/${conversationId}`,
      method: "delete",
    }),
};
